<template>
  <div class="page-banner-area bg-secondary" v-if="product">
    <div class="container mw-1720">
      <div class="page-banner-content">
        <ul class="d-flex align-items-center ps-0 list-unstyled bredcrounbs">
          <li><RouterLink to="/"> الرئيسية </RouterLink></li>
          <li><RouterLink to="/products">المتجر</RouterLink></li>
          <li><span>{{ product.name }}</span></li>
        </ul>
      </div>
    </div>
    
    <div class="container mw-1356">
      <div class="row">
        <div class="col-lg-6">
          <div class="products-details-img">
            <img :src="product.image" :alt="product.name" />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="products-details-content">
            <h2>{{ product.name }}</h2>
            <ul class="ps-0 list-unstyled star d-flex gap-1">
              <li v-for="i in 5" :key="i"><i class="ti ti-star-filled"></i></li>
              <li><span>5.0</span></li>
            </ul>
            
            <h3>
              <del v-if="product.oldPrice">{{ product.oldPrice }} €</del> 
              {{ product.price }} €
            </h3>

            <div class="product-quantity d-flex">
              <div class="add-to-cart-counter d-flex justify-content-between align-content-center">
                <input type="button" class="minusBtn" value="-" @click="decreaseQuantity" />
                <input type="text" class="count" size="25" v-model="quantity" />
                <input type="button" class="plusBtn" value="+" @click="increaseQuantity" />
              </div>
              <button class="btn ms-4" @click="addToCartAction">
                <span class="border-style">إضافة إلى السلة</span>
              </button>
            </div>

            <ul class="ps-0 mb-0 list-unstyled sku-list">
              <li><span class="text-secondary">رمز المنتج (SKU):</span> <span>IPTV-{{ product.id }}</span></li>
              <li><span class="text-secondary">التصنيفات:</span> <span>اشتراكات IPTV</span></li>
              <li><span class="text-secondary">حالة التوفر:</span> <span class="text-grey-teal">متوفر للتفعيل الفوري</span></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <img src="@/assets/images/shape-20.png" class="shape-21 shape" alt="shape" />
    <img src="@/assets/images/shape-21.png" class="shape-22 shape" alt="shape" />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import { useCartStore } from "@/store/index";

export default defineComponent({
  name: "ProductDetailsPage",
  setup() {
    const route = useRoute();
    const cartStore = useCartStore();
    const quantity = ref(1);
    const product = ref<any>(null);

    // هذه قائمة المنتجات (نفسها الموجودة في صفحة المتجر)
    const productsList = [
      { id: 1, image: require("@/assets/images/product-1.jpg"), name: "اشتراك IPTV الماسي - 12 شهر (شاشتين في نفس الوقت)", price: 60.0, oldPrice: 90.0 },
      { id: 2, image: require("@/assets/images/product-2.jpg"), name: "اشتراك IPTV الماسي - 6 أشهر (ثبات مطلق للمباريات)", price: 35.0 },
      { id: 3, image: require("@/assets/images/product-3.jpg"), name: "اشتراك IPTV الماسي - 3 أشهر (جميع القنوات والـ VOD)", price: 25.0 },
      { id: 4, image: require("@/assets/images/product-4.jpg"), name: "جهاز Fire TV Stick 4K مجهز ومبرمج باشتراك سنة كاملة", price: 95.0 },
      { id: 5, image: require("@/assets/images/product-5.jpg"), name: "باقة العائلة المتكاملة - اشتراك IPTV لمدة 12 شهر (3 أجهزة)", price: 85.0 },
      { id: 6, image: require("@/assets/images/product-6.jpg"), name: "اشتراك IPTV VIP - لمدة 12 شهر بجودة 4K حقيقية", price: 70.0 },
      { id: 7, image: require("@/assets/images/product-7.jpg"), name: "جهاز Android TV Box مبرمج بالكامل مع اشتراك 6 أشهر", price: 75.0 },
      { id: 8, image: require("@/assets/images/product-8.jpg"), name: "باقة تجريبية خاصة - اشتراك IPTV لمدة شهر كامل", price: 10.0, oldPrice: 15.0 },
      { id: 9, image: require("@/assets/images/product-9.jpg"), name: "الاشتراك الملكي المستقر - سنتين كاملتين (24 شهر)", price: 110.0 },
    ];

    const loadProduct = () => {
      const productId = Number(route.params.id);
      product.value = productsList.find(p => p.id === productId);
    };

    onMounted(loadProduct);

    // مراقبة تغير الـ ID في الرابط عند التنقل بين المنتجات
    watch(() => route.params.id, loadProduct);

    const increaseQuantity = () => quantity.value++;
    const decreaseQuantity = () => { if (quantity.value > 1) quantity.value--; };

    const addToCartAction = () => {
      if (product.value) {
        cartStore.addToCart({ ...product.value, quantity: quantity.value });
      }
    };

    return {
      product,
      quantity,
      increaseQuantity,
      decreaseQuantity,
      addToCartAction
    };
  },
});
</script>